(() => {
  const moneyFormat = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'de-AT', {
    style: 'currency', currency: currency || 'EUR'
  }).format((Number(cents) || 0) / 100);

  const init = (root) => {
    root.querySelectorAll('[data-melbourne-product]').forEach((productRoot) => {
      if (productRoot.dataset.ready) return;
      productRoot.dataset.ready = 'true';
      const form = productRoot.querySelector('[data-product-form]');
      const dataNode = form && form.querySelector('[data-product-json]');
      if (!form || !dataNode) return;
      let product;
      try { product = JSON.parse(dataNode.textContent); } catch (_) { return; }
      const variantInput = form.querySelector('[data-variant-id]');
      const quantityInput = form.querySelector('[data-product-quantity][name="quantity"]');
      const addButton = form.querySelector('[data-add-button]');
      const addLabel = addButton.querySelector('[data-add-label]') || addButton;
      const stickyBar = productRoot.querySelector('[data-sticky-bar]');
      const stickyButton = stickyBar && stickyBar.querySelector('[data-sticky-submit]');
      const stickyPrice = stickyBar && stickyBar.querySelector('[data-sticky-price]');
      const availability = form.querySelector('[data-availability]');
      const price = productRoot.querySelector('[data-current-price]');
      const compare = productRoot.querySelector('[data-compare-price]');
      const sale = productRoot.querySelector('[data-sale-badge]');
      const error = form.querySelector('[data-product-error]');
      const currency = product.currency || productRoot.dataset.currency || document.documentElement.dataset.currency || 'EUR';
      const optionValues = (variant) => variant.options || [variant.option1, variant.option2, variant.option3].filter((value) => value != null);
      const syncStickyVariant = (variant) => {
        if (!stickyButton) return;
        stickyButton.disabled = !variant || !variant.available;
        if (stickyPrice && variant) stickyPrice.textContent = moneyFormat(variant.price, currency);
      };
      const updateStickyVisibility = () => {
        if (!stickyBar || !addButton) return;
        const ctaRect = addButton.getBoundingClientRect();
        const ctaVisible = ctaRect.top < window.innerHeight && ctaRect.bottom > 0;
        const mainCtaPassed = ctaRect.bottom <= 0;
        const privacySelectors = '#shopify-pc__banner, .shopify-pc__banner, [data-cookie-banner], [data-privacy-banner], .shopify-privacy-banner';
        const visiblePrivacyUi = [...document.querySelectorAll(privacySelectors)].some((element) => {
          const style = window.getComputedStyle(element);
          return !element.hidden && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && element.getBoundingClientRect().height > 0;
        });
        const overlayOpen = Boolean(document.querySelector('dialog[open]'));
        const drawerOpen = document.body.classList.contains('melbourne-cart-lock') || Boolean(document.querySelector('[data-melbourne-cart-root].is-open'));
        const show = mainCtaPassed && !ctaVisible && !overlayOpen && !drawerOpen && !visiblePrivacyUi;
        stickyBar.hidden = !show;
        stickyBar.setAttribute('aria-hidden', String(!show));
      };
      let stickyFrame = 0;
      const scheduleStickyVisibility = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(() => {
          stickyFrame = 0;
          updateStickyVisibility();
        });
      };

      const activeOptions = () => Array.from(productRoot.querySelectorAll('[data-option-group]')).map((group) => {
        const selected = group.querySelector('[data-option-value].is-selected');
        return selected ? selected.dataset.optionValue : null;
      });
      const currentVariant = () => {
        if (!productRoot.querySelector('[data-option-group]')) return product.variants[0];
        const options = activeOptions();
        return product.variants.find((variant) => optionValues(variant).every((value, index) => value === options[index]));
      };
      const activateGalleryImage = (index) => {
        const selectedIndex = String(index);
        productRoot.querySelectorAll('[data-gallery-image], [data-gallery-thumb]').forEach((image) => {
          const active = image.dataset.imageIndex === selectedIndex;
          image.classList.toggle('is-active', active);
          if (image.hasAttribute('aria-pressed')) image.setAttribute('aria-pressed', String(active));
        });
      };
      const applyVariant = (updateUrl = false) => {
        const variant = currentVariant();
        error.hidden = true;
        if (!variant) {
          variantInput.value = '';
          addButton.disabled = true;
          addLabel.textContent = addButton.dataset.unavailable;
          availability.textContent = availability.dataset.unavailable;
          syncStickyVariant(null);
          return;
        }
        variantInput.value = variant.id;
        if (updateUrl && window.history?.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        }
        addButton.disabled = !variant.available;
        syncStickyVariant(variant);
        addLabel.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.unavailable;
        availability.textContent = variant.available ? availability.dataset.available : availability.dataset.unavailable;
        price.textContent = moneyFormat(variant.price, currency);
        const compareAt = Number(variant.compare_at_price || 0);
        if (compareAt > Number(variant.price)) {
          compare.hidden = false;
          compare.textContent = moneyFormat(compareAt, currency);
          sale.hidden = false;
          const savePercent = Math.round(((compareAt - Number(variant.price)) / compareAt) * 100);
          sale.textContent = productRoot.dataset.saveTemplate.replace('MELBOURNE_PERCENT', String(savePercent));
        } else {
          compare.hidden = true;
          sale.hidden = true;
        }
        optionValues(variant).forEach((value, index) => {
          const label = productRoot.querySelector(`[data-option-group][data-option-position="${index + 1}"] [data-option-selected]`);
          if (label) label.textContent = value;
        });
        const galleryImages = [...productRoot.querySelectorAll('[data-gallery-image]')];
        const featuredMediaId = variant.featured_media && variant.featured_media.id;
        const featuredImage = variant.featured_image;
        let variantImage = featuredMediaId != null
          ? galleryImages.find((image) => image.dataset.mediaId === String(featuredMediaId))
          : null;
        if (!variantImage && featuredImage && featuredImage.id != null) {
          variantImage = galleryImages.find((image) => image.dataset.imageId === String(featuredImage.id));
        }
        if (!variantImage && featuredImage && featuredImage.src) {
          const normalizeImagePath = (src) => {
            try { return new URL(src, window.location.href).pathname.toLowerCase(); }
            catch (_) { return String(src).split('?')[0].toLowerCase(); }
          };
          const featuredPath = normalizeImagePath(featuredImage.src);
          variantImage = galleryImages.find((image) => {
            const img = image.querySelector('img');
            return img && normalizeImagePath(img.currentSrc || img.src) === featuredPath;
          });
        }
        if (variantImage) activateGalleryImage(variantImage.dataset.imageIndex);
      };

      productRoot.addEventListener('click', (event) => {
        const optionButton = event.target.closest('[data-option-value]');
        if (optionButton && productRoot.contains(optionButton)) {
          const group = optionButton.closest('[data-option-group]');
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const selected = button === optionButton;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
          applyVariant(true);
        }
        const stickySubmit = event.target.closest('[data-sticky-submit]');
        if (stickySubmit && stickyBar?.contains(stickySubmit)) {
          event.preventDefault();
          if (!addButton.disabled && form.requestSubmit) form.requestSubmit(addButton);
          else if (!addButton.disabled) addButton.click();
        }
        const step = event.target.closest('[data-quantity-step]');
        if (step) {
          const input = form.querySelector('[data-product-quantity]');
          if (input) {
            input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.quantityStep));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        const thumb = event.target.closest('[data-gallery-thumb]');
        const mainImage = event.target.closest('[data-gallery-image]');
        if (thumb || mainImage) {
          const index = (thumb || mainImage).dataset.imageIndex;
          activateGalleryImage(index);
          if (mainImage) {
            const dialog = productRoot.querySelector('[data-zoom-dialog]');
            const image = dialog.querySelector('[data-zoom-image]');
            const source = mainImage.querySelector('img');
            image.src = source.currentSrc || source.src;
            image.dataset.index = index;
            if (dialog.showModal) dialog.showModal();
          }
        }
        const openChart = event.target.closest('[data-size-chart-open]');
        if (openChart) productRoot.querySelector('[data-size-chart-dialog]')?.showModal();
        const close = event.target.closest('[data-dialog-close]');
        if (close) close.closest('dialog')?.close();
        const navigate = event.target.closest('[data-zoom-prev], [data-zoom-next]');
        if (navigate) {
          const images = [...productRoot.querySelectorAll('[data-gallery-image]')];
          if (!images.length) return;
          const old = Number(productRoot.querySelector('[data-zoom-image]').dataset.index || 0);
          const delta = navigate.matches('[data-zoom-next]') ? 1 : -1;
          images[(old + delta + images.length) % images.length].click();
        }
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const variant = currentVariant();
        if (!variant || !variant.available) return;
        addButton.disabled = true;
        if (stickyButton) {
          stickyButton.disabled = true;
          stickyButton.setAttribute('aria-busy', 'true');
        }
        error.hidden = true;
        try {
          if (quantityInput) quantityInput.value = String(Math.max(1, parseInt(quantityInput.value, 10) || 1));
          const formData = new FormData(form);
          if (!formData.has('quantity')) formData.set('quantity', '1');
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST', headers: { Accept: 'application/json' }, body: formData
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || productRoot.dataset.genericError);
          if (window.MelbourneCart) {
            try { await window.MelbourneCart.refresh(); } catch (_) { /* The item was added; keep the confirmation independent. */ }
            window.MelbourneCart.open();
          }
        } catch (err) {
          error.textContent = err.message;
          error.hidden = false;
        } finally {
          const latestVariant = currentVariant();
          addButton.disabled = !latestVariant || !latestVariant.available;
          syncStickyVariant(latestVariant);
          stickyButton?.removeAttribute('aria-busy');
        }
      });
      applyVariant();
      if (stickyBar && addButton) {
        let stickyObserver;
        let stickyUiObserver;
        const openExternalSizeChart = (event) => {
          const trigger = event.target.closest?.('[data-size-chart-open]');
          if (!trigger || productRoot.contains(trigger)) return;
          const chart = productRoot.querySelector('[data-size-chart-dialog]');
          if (chart?.showModal && !chart.open) chart.showModal();
        };
        document.addEventListener('click', openExternalSizeChart);
        if ('IntersectionObserver' in window) {
          stickyObserver = new IntersectionObserver(scheduleStickyVisibility);
          stickyObserver.observe(addButton);
        }
        window.addEventListener('scroll', scheduleStickyVisibility, { passive: true });
        window.addEventListener('resize', scheduleStickyVisibility);
        stickyUiObserver = new MutationObserver(scheduleStickyVisibility);
        stickyUiObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'open'], childList: true, subtree: true });
        document.addEventListener('toggle', scheduleStickyVisibility, true);
        const cleanupSticky = (event) => {
          if (!event.target?.contains?.(productRoot) && event.target !== productRoot) return;
          stickyObserver?.disconnect();
          stickyUiObserver?.disconnect();
          window.removeEventListener('scroll', scheduleStickyVisibility);
          window.removeEventListener('resize', scheduleStickyVisibility);
          document.removeEventListener('toggle', scheduleStickyVisibility, true);
          document.removeEventListener('click', openExternalSizeChart);
          document.removeEventListener('shopify:section:unload', cleanupSticky);
        };
        document.addEventListener('shopify:section:unload', cleanupSticky);
        scheduleStickyVisibility();
      }
    });
    root.querySelectorAll('[data-product-recommendations]:not([data-recommendations-ready])').forEach(async (container) => {
      container.dataset.recommendationsReady = 'true';
      try {
        const response = await fetch(container.dataset.url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fragment = doc.querySelector('[data-product-recommendations]');
        if (fragment && fragment.querySelector('.melbourne-recommendation')) {
          container.innerHTML = fragment.innerHTML;
          container.hidden = false;
        }
      } catch (_) { /* Recommendations are optional. */ }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

